export default __webpack_public_path__ + "static/media/2408242.60440a35.webp";